<template>
  <nav class="landing_dark" role="navigation">
    <div class="nav-wrapper container">
      <router-link to="/" id="logo-container" class="brand-logo">Supersquares.co</router-link>
      <ul class="right hide-on-med-and-down">
        <li></li>
      </ul>

      <ul id="nav-mobile" class="side-nav">
        <li></li>
      </ul>
      <a href="#" data-activates="nav-mobile" class="button-collapse">
        <i class="material-icons"></i>
      </a>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'Header'
}
</script>

<style>
</style>
